module.exports = __webpack_public_path__ + "img/26.afd157b1.png";